
const icons = {};

icons.codesnippet = <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
width="682.000000pt" height="416.000000pt" viewBox="0 0 682.000000 416.000000"
preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,416.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M3400 3730 l0 -430 84 0 85 0 512 -465 512 -464 76 68 c42 38 272
247 511 465 l435 396 88 0 87 0 -2 -1222 -3 -1223 -242 -3 -243 -2 -2 751 -3
750 -348 -316 c-192 -175 -353 -314 -360 -312 -7 3 -165 145 -352 316 l-340
310 -3 -750 -2 -749 -245 0 -245 0 0 -425 0 -425 1710 0 1710 0 0 2080 0 2080
-1710 0 -1710 0 0 -430z"/>
<path d="M1030 2075 l0 -1225 404 0 c438 0 505 6 661 57 584 190 938 766 840
1368 -71 442 -394 821 -821 964 -161 54 -236 61 -681 61 l-403 0 0 -1225z
m888 706 c203 -59 369 -195 458 -376 60 -123 78 -196 77 -330 0 -129 -17 -204
-73 -320 -91 -188 -257 -327 -460 -385 -57 -16 -114 -23 -237 -27 l-163 -6 0
738 0 738 163 -6 c122 -4 180 -11 235 -26z"/>
</g>
</svg>

export default icons;
